<template>
  <input-base
      ref="base"
      :read-only="readOnly || !hasAccessToList"
      :editor-mode="editorMode"
      :staticLabel="staticLabel"
      :isStatic="true"
      :validatedField="validatedField"
      :fieldConfig="supplierFieldConfig"
      v-if="loaded"
  >
    <template slot="readOnly">
      <div v-html="formattedValue"></div>
    </template>

    <template slot="editor">
      <div class="form-control grey-label readonly-input">
        <div v-html="formattedValue"></div>
      </div>
      <b-button

          data-test-path="select-button"
          class="form-button ml-1 d-none d-xl-inline-block"
          variant="plm-action"
          :disabled="readOnly"
          @click="changeParent"
      >
        <font-awesome-icon icon="pencil-alt" class="mr-2"/>
        {{$tr("Select","Select")}}
      </b-button>
      <b-button
          class="form-button-icon ml-1 d-xl-none"
          variant="plm-action"
          :disabled="readOnly"
          @click="changeParent"
      >
        <font-awesome-icon icon="pencil-alt" class="mr-2"/>
      </b-button>
    </template>

    <template slot="label-links">
      <!--    TODO moze kiedys z tym wrocimy, na razie usuwamy - wprowadza zbyt wiele bledow w systemie, dzialanie tych przyciskow jest niepoprawnie obsluzone-->
      <!--      <span v-if="editEnabled && selectedValue" class="pl-0">-->
      <!--        <b-link v-if="editEnabled && selectedValue" @click="edit()" class="px-0 pr-1 pl-1"-->
      <!--                style=" height: 16px;">-->
      <!--            <font-awesome-icon icon="pencil-alt" transform="shrink-4"></font-awesome-icon>-->
      <!--        </b-link>-->
      <!--      </span>-->
    </template>

  </input-base>

</template>

<script>

import FormsLoader from "@/components/forms/FormsLoader";
import FormsActions from "@/components/forms/FormsActions";
import FormsAI from "@/components/forms/FormsAI";
import InputBase from "@/components/inputs/InputBase";
import ValidatedField from "@/validation/ValidatedField";
import Product from "@/server/com/silkplm/model/plm/Product";
import ValidatedForm from "@/validation/ValidatedForm";

export default {
  name: "SelectActivityInput",
  components: {InputBase},
  beforeMount() {

  },

  async created() {
    let formProduct = FormsLoader.detectFormConfig(Product.getRemoteClass());

    for (let field of formProduct.fields) {
      if (field.fieldName === "supplierId") {
        this.supplierFieldConfig = field
      }
    }
  },

  async mounted() {
    let form = FormsLoader.detectFormConfig(this.formClass);
    this.hasAccessToList = form.restrictedList ? SessionManager.hasPermission(form.effectivePermissionList) : true;

    this.valChange(this.selectedValue);
    this.addEnabled = form.writePermitted;
    this.editEnabled = form.writePermitted;
    this.loaded = true;
  },

  props: {
    initialSelectedValue: {default: null},
    formClass: {required: true},
    staticLabel: {default: null}
  },
  watch: {
    'selectedValue': function (val) {
      this.valChange(val);
    },
  },
  methods: {
    valChange(val) {
      this.$emit("change", val);
    },

    async changeParent() {
      // add title
      let filter = null;
      // todo - props with filter

      let activity = await FormsActions.showSelectList(
          this.formClass,
          {filter});

      /** @type {} */
      let result = await activity.getResult();
      if (Array.isArray(result) && result.length > 0) {
        result = result[0];
      }
      if (result === null) {
        this.selectedValue = null;
        this.valChange(null);
      } else if (result !== undefined) {
        const title = FormsAI.getEntityLabel(FormsLoader.detectFormConfig(this.formClass), result);
        this.selectedValue = result;
        this.formattedValue = title;
      }
    },

    setReadOnly(readOnly) {
      this.readOnly = readOnly;
    },

    setEditorMode(val) {
      this.editorMode = val
    },

    async edit() {
      if (this.selectedValue) {
        let entity = await Rpc.Forms.getEntity(this.formClass, this.selectedValue)
        await FormsActions.edit(entity);
      }
    },
  },

  data: () => ({
    selectedValue: null,
    hasAccessToList: false,
    options: [],
    idToLabel: new Map(),

    readOnly: false,
    editorMode: true,

    loadInProgress: false,
    currentOpt: {},
    valueSetFromList: false,
    valueSetFromCurrent: false,
    nullAdded: false,
    listLoaded: false,
    optionsList: [],
    nullRow: {value: null, text: ''},
    formattedValue: "",

    addEnabled: false,
    editEnabled: false,
    supplierFieldConfig: null,
    validatedField: new ValidatedField(new ValidatedForm(), ""),
    loaded: false
  })
}
</script>

<style scoped>

</style>